import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import RatingsPicker from './common/RatingsPicker';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import {
  SortBtn,
  SortBtnContainer,
  CatMenu,
  SubCatMenu,
  DateMenu,
  PriceMenu,
  RadiusMenu,
  SortMenu,
  MenuChoice,
  PriceInput,
  PriceMenuColumn,
  InputLabel,
  PriceInputBar,
  ApplyButton,
  PriceMenuForm,
  RangeSlider,
  RadiusMenuForm,
  Miles,
  Text,
  SortMenuButton,
  ToggleSwitch,
  MapText,
} from './SortBarComps';
import { Flex, Box } from 'rebass';
import { Text as TextCommon } from './common';
import DateRange from './common/FormComponents/DateRange/SearchDateRange';
// const Something = styled(Box)`
// `

class SortBar extends Component {
  constructor() {
    super();
    this.sortButton = null;
    this.datesButton = null;
    this.priceButton = null;
    this.radiusButton = null;
  }

  state = {
    catSelected: null,
    subCatSelected: null,
    datesSelected: null,
    priceSelected: null,
    radiusSelected: 25,
    radiusChanged: false,
    radiusButtonTitle: 'Radius',
    sortSelected: null,
    priceMin: '',
    priceMax: '',
    minRating: 0,
    sortHighLow: null,
    mapActive: true,
    datesOffset: '267px',
    priceOffset: '352px',
    radiusOffset: '434px',
    sortOffset: '527px',
    categoryChoices: [
      { name: 'Business Equipment', id: 89 },
      { name: 'Clothing', id: 74 },
      { name: 'DVDs & Video Games', id: 97 },
      { name: 'Electronics', id: 85 },
      { name: 'Home and Garden', id: 77 },
      { name: 'Lawn and Garden', id: 93 },
      { name: 'Misc', id: 95 },
      { name: 'Music', id: 96 },
      { name: 'Outdoor Gear', id: 84 },
      { name: 'Party & Wedding Equipment', id: 88 },
      { name: 'Recreational Vehicles', id: 91 },
      { name: 'Sporting Equipment', id: 76 },
      { name: 'Tools', id: 86 },
      { name: 'Toys and Games', id: 87 },
      { name: 'Venues', id: 92 },
    ],
  };

  makeSelection = val => {
    this.props.updateSelection(val);
    this.props.darkenBackground();
  };
  updateChoice = (cat, choice) => {
    this.setState({ [cat]: choice });
    this.props.change('SearchForm', 'roomType', [choice.id]);
    setTimeout(() => this.recalcPositions());
    this.props.removeBackground();
  };

  componentDidMount() {
    this.recalcPositions();
  }
  recalcPositions() {
    //sort, radius, price, dates, categories
    const sortBtn = ReactDOM.findDOMNode(this.sortButton);
    const datesBtn = ReactDOM.findDOMNode(this.datesButton);
    const priceBtn = ReactDOM.findDOMNode(this.priceButton);
    const radiusBtn = ReactDOM.findDOMNode(this.radiusButton);

    const sortLeft = sortBtn && sortBtn.offsetLeft;
    const datesLeft = datesBtn && datesBtn.offsetLeft;
    const priceLeft = priceBtn && priceBtn.offsetLeft;
    const radiusLeft = radiusBtn && radiusBtn.offsetLeft;

    this.setState({
      datesOffset: datesLeft + 'px',
      priceOffset: priceLeft + 'px',
      radiusOffset: radiusLeft + 'px',
      sortOffset: sortLeft + 'px',
    });
  }
  updatePrice = ({ target }, minOrMax) => {
    // if(this.state.priceMax && minOrMax === 'priceMin' && target.value > this.state.priceMax) return;
    this.setState({ [minOrMax]: target.value });
    setTimeout(() => this.recalcPositions());
  };
  applyPrice = e => {
    e.preventDefault();
    let { priceMin, priceMax } = this.state;
    let priceValues;
    if (priceMax && priceMin) priceValues = `$${priceMin}-$${priceMax}`;
    else if (priceMin) priceValues = `$${priceMin} (min)`;
    else if (priceMax) priceValues = `$${priceMax} (max)`;
    else priceValues = null;

    this.setState({
      priceSelected: priceValues,
    });
    this.props.removeBackground();
    this.props.change('SearchForm', 'priceRange', [priceMin, priceMax]);
  };
  updateRadius = ({ target }) => {
    this.setState({ radiusSelected: target.value });
    setTimeout(() => this.recalcPositions());
  };
  closeRadiusMenu = e => {
    e.preventDefault();
    this.setState({
      radiusChanged: true,
      radiusButtonTitle: `${this.state.radiusSelected} miles`,
    });
    this.props.removeBackground();
    this.props.change(
      'SearchForm',
      'radiusMiles',
      parseInt(this.state.radiusSelected),
    );
  };

  changeMinRating = rating => {
    this.setState({ minRating: rating });
    setTimeout(() => this.recalcPositions());
  };
  changeSortHighLow = val => {
    this.setState({ sortHighLow: val });
    setTimeout(() => this.recalcPositions());
  };

  applySort = () => {
    let { sortHighLow, minRating } = this.state;
    let result = sortHighLow === 'high' ? 'High - Low' : 'Low - High';
    if (!sortHighLow) result = null;
    // this.updateChoice('sortSelected', result);
    this.props.change('SearchForm', 'minimumRating', parseInt(minRating));
    this.props.change(
      'SearchForm',
      'priceSort',
      sortHighLow === 'high' ? 'DESC' : 'ASC',
    );
    setTimeout(() => this.recalcPositions());
  };

  render() {
    const {
      catSelected,
      subCatSelected,
      datesSelected,
      priceSelected,
      radiusSelected,
      sortSelected,
      minRating,
      sortHighLow,
      radiusButtonTitle,
      radiusChanged,
      mapActive,
    } = this.state;
    let { currentSelection } = this.props;
    let containerStyle = { position: 'relative' };
    let catChoices = this.state.categoryChoices.map((cat, i) => {
      return (
        <form onSubmit={() => this.updateChoice('catSelected', cat)}>
          <MenuChoice key={cat.id}>{cat.name}</MenuChoice>
        </form>
      );
    });
    return (
      <div style={containerStyle}>
        <SortBtnContainer>
          <SortBtn
            type="button"
            selectionMade={catSelected ? true : false}
            onClick={() => this.makeSelection('Categories')}
            id="category-button"
          >
            {catSelected ? catSelected.name : 'Categories'}
          </SortBtn>
          <SortBtn
            type="button"
            selectionMade={datesSelected ? true : false}
            onClick={() => this.makeSelection('Dates')}
            ref={ele => (this.datesButton = ele)}
            id="dates-button"
          >
            {currentSelection === 'Dates' ? 'Pickup - Dropoff' : 'Dates'}
          </SortBtn>
          <SortBtn
            type="button"
            selectionMade={priceSelected ? true : false}
            onClick={() => this.makeSelection('Price')}
            ref={ele => (this.priceButton = ele)}
            id="price-button"
          >
            {priceSelected ? priceSelected : 'Price'}
          </SortBtn>
          {/* <SortBtn
            type="button"
            selectionMade={radiusChanged ? true : false}
            onClick={() => this.makeSelection('Radius')}
            ref={ele => (this.radiusButton = ele)}
          >
            {radiusButtonTitle}
          </SortBtn> */}
          <SortBtn
            type="button"
            selectionMade={sortSelected ? true : false}
            onClick={() => this.makeSelection('Sort')}
            ref={ele => (this.sortButton = ele)}
            id="sort-button"
          >
            {sortSelected ? sortSelected : 'Sort'}
          </SortBtn>

          <ToggleSwitch
            onClick={() => this.setState({ mapActive: !mapActive })}
            src={mapActive ? '/icons/active.svg' : '/icons/inactive.svg'}
            id="map-switch"
          />
          <MapText>ShowMap</MapText>
        </SortBtnContainer>
        {/* VVV DROP DOWN MENUS VVV */}
        {currentSelection === 'Categories' ? (
          <CatMenu>{catChoices}</CatMenu>
        ) : null}
        {currentSelection === 'Sub-Categories' ? <SubCatMenu /> : null}
        {currentSelection === 'Dates' ? (
          <DateMenu offset={this.state.datesOffset} id="date-menu">
            <Box>
              <TextCommon xLarge primary mb={3}>
                Select your desired rental window
              </TextCommon>
              <DateRange
                name="dates"
                formName={'SearchForm'}
                numberOfMonths={1}
                setPersonalizedValues={
                  this.props.setPersonalizedValues ||
                  (() => console.log('Date received boss!'))
                }
                onChange={
                  this.props.dateFilterChange ||
                  ((formName, fieldName, value) => {
                    console.log(formName, fieldName, value);
                  })
                }
              />
            </Box>
            <ApplyButton type="submit" name="submit-button-dates">
              APPLY
            </ApplyButton>
          </DateMenu>
        ) : null}
        {currentSelection === 'Price' ? (
          <PriceMenu offset={this.state.priceOffset} id="price-menu">
            <PriceMenuForm onSubmit={this.applyPrice}>
              <PriceMenuColumn>
                <InputLabel>Min</InputLabel>
                <PriceInput
                  type="number"
                  onChange={e => this.updatePrice(e, 'priceMin')}
                  placeholder="Optional"
                  value={this.state.priceMin}
                  id="price-min-text"
                />
              </PriceMenuColumn>
              <PriceInputBar />
              <PriceMenuColumn>
                <InputLabel>Max</InputLabel>
                <PriceInput
                  type="number"
                  onChange={e => this.updatePrice(e, 'priceMax')}
                  placeholder="Optional"
                  value={this.state.priceMax}
                  id="price-max-text"
                />
              </PriceMenuColumn>
              <ApplyButton type="submit" id="submit-button-price">
                APPLY
              </ApplyButton>
            </PriceMenuForm>
          </PriceMenu>
        ) : null}
        {/* {currentSelection === 'Radius' ? (
          <RadiusMenu offset={this.state.radiusOffset}>
            <RadiusMenuForm onSubmit={this.closeRadiusMenu}>
              <Miles>{`${radiusSelected} miles`}</Miles>
              <RangeSlider
                type="range"
                min="1"
                max="50"
                value={this.state.radiusSelected}
                onChange={this.updateRadius}
              />
              <ApplyButton type="submit">APPLY</ApplyButton>
            </RadiusMenuForm>
          </RadiusMenu>
        ) : null} */}
        {currentSelection === 'Sort' ? (
          <form onSubmit={this.applySort}>
            <SortMenu offset={this.state.sortOffset} id="sort-menu">
              <Text size="20px" weight="bold" primary family="Metropolis">
                PRICE
              </Text>
              <SortMenuButton
                type="button"
                selected={sortHighLow === 'high' ? true : false}
                onClick={() => this.changeSortHighLow('high')}
                id="sort-price-button-high"
              >
                High - Low
              </SortMenuButton>
              <SortMenuButton
                type="button"
                selected={sortHighLow === 'low' ? true : false}
                onClick={() => this.changeSortHighLow('low')}
                id="sort-price-button-low"
              >
                Low - High
              </SortMenuButton>
              <Text size="20px" weight="bold" primary family="Metropolis">
                RATINGS
              </Text>
              <Text
                family="Helvetica"
                size="14px"
                weight="normal"
                color="#595959"
                margin="6px 0px"
              >
                Min. Rating
              </Text>
              <RatingsPicker
                medium
                rating={minRating}
                changeMinRating={this.changeMinRating}
                id="ratings-picker"
              />
              <ApplyButton type="submit" id="submit-button-sort">
                APPLY
              </ApplyButton>
            </SortMenu>
          </form>
        ) : null}
      </div>
    );
  }
}

export default connect(
  null,
  { change },
)(SortBar);



// WEBPACK FOOTER //
// ./src/components_new/SortBar.js